<template>
  <el-submenu
    v-if="item.children && item.children.length > 0"
    :index="item.index"
  >
    <template slot="title">
      <i
        v-show="item.class"
        class="menu-icon"
        :class="item.class"
      />
      <span class="menu-span">{{ item.label }}</span>
    </template>
    <recursive-menu-item
      v-for="(child, idx) in item.children"
      :key="idx"
      :item="child"
    />
  </el-submenu>
  <el-menu-item
    v-else
    :index="item.index"
  >
    <i
      v-show="item.class"
      class="menu-icon"
      :class="item.class"
    />
    <span class="menu-span">{{ item.label }}</span>
  </el-menu-item>
</template>

<script>
import { RecursiveMenuItem } from './index';
export default {
    name: 'RecursiveMenuItem',
    components: { RecursiveMenuItem },
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style scoped lang="scss">
.el-submenu__title .menu-span {
  margin-right: 20px;
}
</style>
